<!-- prettier-ignore -->
<template>
    <div>
        <template v-if="loading">
            <v-skeleton-loader
                v-for="i in 10"
                :key="i"
                type="image"
                class="mb-4"
            ></v-skeleton-loader>
        </template>

        <v-card
            v-else
            v-for="(explanation, i) in explanations.data"
            :key="i"
            class="mb-4 pb-2"
        >
            <div class="d-flex justify-space-between align-center">
                <div>
                    <v-card-title>
                        <span class="mr-4">
                            {{ explanation.number }}.
                        </span>
                    </v-card-title>

                    <v-card-subtitle class="pb-0">
                        <v-icon v-if="explanation.flagged" color="error">mdi-flag</v-icon>
                        {{ explanation.field }}
                    </v-card-subtitle>
                </div>
            </div>

            <v-card-text class="black--text pb-0 body-1">
                <div
                    v-if="explanation.image"
                    v-viewer='{ "inline": false, "button": true, "navbar": false, "title": false, "toolbar": false, "tooltip": false, "movable": true, "zoomable": true, "rotatable": false, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }'
                    class="d-flex justify-center"
                    >
                        <img width="400" :src="assetUrl(explanation.image)">
                </div>

                {{ explanation.question }}

                <v-list-item v-if="explanation.user_answer === null">
                    <v-list-item-content>
                        <v-list-item-title class="error--text body-1">
                            <v-icon color="red">mdi-close</v-icon>
                            Tidak dijawab
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <answer-display
                    :explanation="explanation"
                    :hidings="explanations.hidings"
                    :tryoutHidings="explanations.tryout_hidings"
                ></answer-display>
            </v-card-text>

            <div
                v-if="explanation.has_explanation_image || explanation.explanation_video_id || (((periodId == 34 || periodId == 40) && explanation.number <= 30)) || (periodId == 45 && explanation.number <= 100)"
                class="ml-4 mt-2"
            >
                <v-btn
                    v-if="explanation.has_explanation_image"
                    @click="selectedQuestionIdForExplanation = explanation.question_id"
                    color="primary"
                    rounded
                    outlined
                    class="mr-2"
                >
                    <v-icon left>mdi-image</v-icon>
                    Pembahasan
                </v-btn>

                <v-btn
                    v-if="explanation.explanation_video_id"
                    @click="selectedVideoId = explanation.explanation_video_id"
                    color="primary"
                    rounded
                    outlined
                >
                    <v-icon left>mdi-video</v-icon>
                    Pembahasan Video
                </v-btn>
            </div>

            <explanation-hiding-tryout-question-description
                :explanation="explanation"
                :hidings="explanations.hidings"
                class="ml-4 mt-2"
            ></explanation-hiding-tryout-question-description>
        </v-card>

        <explanation-image-viewer v-model="selectedQuestionIdForExplanation"></explanation-image-viewer>
        <explanation-video-viewer v-model="selectedVideoId"></explanation-video-viewer>
    </div>
</template>

<script>
import { get } from 'vuex-pathify'
import ExplanationImageViewer from './ExplanationImageViewer'
import ExplanationVideoViewer from './ExplanationVideoViewer'
import AnswerDisplay from './components/AnswerDisplay.vue'
import ExplanationHidingTryoutQuestionDescription from './components/ExplanationHidingTryoutQuestionDescription.vue'
import assetUrl from '@/tools/assetUrl'

export default {
    components: {
        ExplanationImageViewer,
        ExplanationVideoViewer,
        AnswerDisplay,
        ExplanationHidingTryoutQuestionDescription,
    },

    computed: {
        loading: get('explanation/loading'),
        explanations: get('explanation/explanation'),
        periodId: get('enrollment/selected@id'),
    },

    data() {
        return {
            selectedQuestionIdForExplanation: null,
            selectedVideoId: null,
        }
    },

    methods: {
        assetUrl,
    },
}
</script>
